import { ICardHolder } from './card-holder.model';
import { ICardHolderAccount } from './card-holder-account.model';
import { IBrowserInformation } from './browser-information.model';
import { IAcquirer } from './acquirer.model';

export interface IAuthenticationRequest {
  cardholderAccount?: ICardHolderAccount;
  cardholder?: ICardHolder;
  browserInformation?: IBrowserInformation;
  acquirer?: IAcquirer,
  threeDSCompInd?: string
}

export class AuthenticationRequest implements IAuthenticationRequest {
  constructor(
    cardholderAccount?: ICardHolderAccount,
    cardholder?: ICardHolder,
    browserInformation?: IBrowserInformation,
    acquirer?: IAcquirer,
    threeDSCompInd?: string
  ) {}
}
